import { Heading } from './Heading.styles';

export const HomeHeading = () => {
  return <Heading>Coinpaper</Heading>;
};
